// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ExpandableClamp__label":"bbm_a bhk_hg bhk_ry bhk_xj"};